// Percentages describe measurable work within the named stage, not a guessed ETA.
export function installGraphLoading(document) {
  const panel = document.querySelector('#graphLoading');
  const text = document.querySelector('#graphLoadingText');
  const bar = document.querySelector('#graphLoadingProgress');
  let complete = false, broken = false, layoutProgress = 0;
  function show(phase, message, fraction = null) {
    if (complete || broken || !panel || !text) return;
    panel.hidden = false;
    panel.dataset.phase = phase;
    const percent = fraction === null ? null : Math.min(100, Math.max(0, Math.floor(fraction * 100)));
    if (bar) {
      bar.hidden = false;
      if (percent === null) bar.removeAttribute('value');
      else bar.value = percent;
    }
    const label = message + (percent === null ? '' : ` ${percent} %`);
    if (text.textContent !== label) text.textContent = label;
  }
  return {
    fetching() { layoutProgress = 0; show('fetching', 'Téléchargement du réseau…'); },
    preparing(progress) { show('preparing', 'Préparation des groupes affichés :', progress); },
    arranging(progress = 0) {
      layoutProgress = Math.max(layoutProgress, progress);
      show('arranging', layoutProgress >= 1 ? 'Finalisation de l’affichage…' : 'Disposition du réseau :', layoutProgress >= 1 ? null : layoutProgress);
    },
    retrying() { show('retrying', 'Connexion indisponible — nouvelle tentative…'); },
    failed() { show('error', 'Le réseau n’a pas pu s’afficher. Rechargez la page.'); broken = true; if (bar) bar.hidden = true; },
    ready() {
      complete = true;
      if (bar) bar.value = 100;
      if (panel) { panel.hidden = true; panel.dataset.phase = 'ready'; }
      if (text) text.textContent = '';
    },
  };
}
